module.exports = __webpack_public_path__ + "img/i_frontier-mission_off.20527b6.png";